import { createContext, PropsWithChildren, useReducer } from "react";

import {
  UpdateSourceRequest,
  UpdateSourceResponse,
} from "@gx/ts-contracts/services/source/api/source_pb";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import { EditSourceFormAction } from "@/pages/sources/components/edit/actions";
import editSourceFormReducer from "@/pages/sources/components/edit/reducer";
import { type EditSourceFormState } from "@/pages/sources/components/edit/types";

export type EditSourceFormContextShape = {
  state: EditSourceFormState;
  dispatch: React.Dispatch<EditSourceFormAction>;
};

export const DEFAULT_STATE: EditSourceFormState = {
  source: {} as SourceResource,
  isLoading: false,
  isUpdateSourceSucceeded: false,
  shouldShowErrors: false,
  errors: [],
  updateSourceRequest: {} as UpdateSourceRequest,
  updateSourceResponse: {} as UpdateSourceResponse,
};

const DEFAULT_CONTEXT: EditSourceFormContextShape = {
  state: DEFAULT_STATE,
  dispatch: () => undefined,
};

export const EditSourceFormContext = createContext<EditSourceFormContextShape>(DEFAULT_CONTEXT);
EditSourceFormContext.displayName = "EditSourceFormContext";

const EditSourceFormProvider = ({
  children,
  initialState,
}: PropsWithChildren<{
  initialState?: EditSourceFormState;
}>) => {
  const state = initialState ?? DEFAULT_STATE;
  const [currentState, dispatch] = useReducer(editSourceFormReducer, state);

  return (
    <EditSourceFormContext.Provider value={{ state: currentState, dispatch }}>
      {children}
    </EditSourceFormContext.Provider>
  );
};

export default EditSourceFormProvider;
